<template>
    <div class="container-center">

        <el-form class="contract-form" label-width="140px" :model="searchForm" >

            <el-row>

                <el-col :span="7">
                    <el-form-item label="名称：" prop="title">
                        <el-input size="medium" v-model="searchForm.title" clearable></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="3" :offset="2">
                    <el-button type="warning" class="btn-theme" size="medium" @click="getBugList" icon="el-icon-search">搜索</el-button>
                </el-col>

            </el-row>

        </el-form>

        <div class="msgex-list-box">
            <div class="no-data-tip" v-if="bugguideList.length == 0"></div>

            <div class="msgex-title-top" v-for="(li,index) in bugguideList" :name="index" :key="index">
                <span @click="showDialog(li.id)" :title="li.title" class="title big">{{ li.title || '#缺省#' }}</span>
                <span class="date">{{ li.createDate }}</span>
            </div>
        </div><!-- .msgex-list-box -->

        <div class="block">
            <el-pagination
                background
                prev-text="上一页"
                next-text="下一页"
                layout="total, prev, pager, next"
                :page-size="10"
                :current-page="pager.pageNum"
                :total="pager.total"
                @current-change="handleCurrentChange"
            ></el-pagination>
        </div>

        <el-dialog title="缺陷指引详情" 
        :visible.sync="showFlag" width="900px" 
        :close-on-click-modal="false" center>

            <div class="container-center">
                <div class="inviteInfo dashed">
                    <h5>名称：</h5>
                    <div v-if="!baseInfo.title" class="no-data-tip" ></div>
                    <div v-else class="text" v-html="baseInfo.title"></div>
                </div>
                <div class="inviteInfo dashed">
                    <h5>附件：</h5>
                    <div v-if="baseInfo.baseFiles.length == 0" class="no-data-tip"></div>
                    <ul v-else class="invite-mng-list">
                        <li v-for="li in baseInfo.baseFiles" :key="li.id"><a :href="downloadApi +'?name='+ li.fileOldName +'&path='+ li.filePath" target="_blank">{{ li.fileOldName }}</a></li>
                    </ul>
                </div>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import util from '@/util'
import banner from '@/assets/imgs/banner_inviteMng.png'

export default {
    name:'bugguide',    
    data(){
        return {
            bugguideList: [],
            pager:{
                total: 0,
                pageNum: 1,
                pageSize: 10
            },
            searchForm: {
                title: ''
            },
            downloadApi: `${util.baseUrl}rest/api/sftp/download`,
            showFlag: false,
            baseInfo: {
                title: '',
                baseFiles: []
            }
        }

    },
    methods:{
        // 分页处理
        handleCurrentChange (page) {
            this.pager.pageNum = page;
            this.getBugList();
        },
        // 获取信息互通列表
        getBugList () {
            this.searchForm.pageNum = this.pager.pageNum
            this.searchForm.pageSize = this.pager.pageSize
            this.searchForm.delFlag = '0'

            const loading = this.$loading({background:'rgba(255,255,255,0.5)'});
            this.$http.post('rest/api/dsp/bugguide/getBugGuideList', this.searchForm).then((res)=>{
                loading.close();
                if(res.data.result) {
                    this.bugguideList = res.data.value.list;
                    this.pager.total = res.data.value.count;
                    this.pager.pageNum = res.data.value.pageNo;
                } else {
                    this.$message({message: res.data.message, type: 'error'})
                }
            })

        },
        showDialog (id) {
            this.$http.get(`rest/api/dsp/bugguide/getDetial/${id}`).then((res)=>{
                if(res.data.result) {
                    this.baseInfo = res.data.value;
                    this.showFlag = true
                } else {
                    this.$message({message: res.data.message, type: 'error'})
                }
            })
        }
    },
    created(){
        this.$root.navs = [{name:'缺陷指引',path:'/bugguideList'}]
        this.$root.headImage.src = banner
        this.$root.isPublic = false;
        this.getBugList()
    },
    
}
</script>


<style lang="postcss" scoped>
@import '../../../../assets/common.css';
.tabs{
    margin-top:25px;
}
.contract-form {background: #F5F6F5;padding: 25px 10px 10px 10px;margin: 24px 0;}

.msgex-list-box {
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #d1cccc;
    border-bottom: 1px solid #d1cccc;
}

.msgex-list-box .title {display:inline-block;font-size:16px;cursor:pointer;font-weight:bold;width:280px;overflow:hidden;text-overflow:ellipsis;white-space: nowrap;}
.msgex-list-box .date {float:right;color:#8c8c8c;}

a {color:var(--cMain);}

ul {padding: 0;margin:0; width: 800px;}
ul li {list-style:none;}

ul.invite-mng-list li {padding:8px 12px;font-size:14px;}
ul.invite-mng-list li:nth-child(odd) {background:#f8f8f8;}
ul.invite-mng-list li a {color:var(--cTxt1);text-decoration:none;}
ul.invite-mng-list li a:hover {color:var(--cMain);}

.inviteInfo {font-size: 14px;}
.inviteInfo.solid {height: 100px;border-bottom: 1px solid #E6E7E6;padding-top: 50px;}
.inviteInfo.solid > p {margin: 0 0 24px 0;color: #000;font-size: 14px;}
.inviteInfo.solid > p.title {font-size: 18px;font-weight: bold;}
.inviteInfo.dashed {padding-bottom: 10px;border-bottom: 1px dashed #E6E7E6;}

.inviteInfo h5 {color: #252525;font-size: 15px;margin: 16px 0;}
.inviteInfo h5::before {content: '';display: inline-block;width: 5px;height: 5px;background: var(--cMain);vertical-align: middle;margin: 0 10px;}
.inviteInfo .filelink a{display: block;margin: 10px 0;color: var(--blueColor);}

.inviteInfo .text {padding:20px;}
</style>




// WEBPACK FOOTER //
// src/pages/dsp/cr9/bugguide/bugguideList.vue